import { extendTheme } from "@chakra-ui/react";
import { globalStyles } from "./styles";
import { breakpoints } from "./foundations/breakpoints";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { linkStyles } from "./components/link";
import { inputStyles } from "./components/input";
import { CardComponent } from "./additions/card/Card";
import { MainPanelComponent } from "./additions/layout/MainPanel";
import { PanelContentComponent } from "./additions/layout/PanelContent";
import { PanelContainerComponent } from "./additions/layout/PanelContainer";
// import { mode } from "@chakra-ui/theme-tools";

export default extendTheme(
  { 
    breakpoints,
    direction: "rtl", // Enable RTL globally
    fonts: {
      heading: "'Amiri', serif",
      body: "'Amiri', serif",
      mono: "'Amiri', serif", // Override monospace too
    },
    styles: {
      global: {
        "*": {
          fontFamily: "'Amiri', serif !important",
        },
        "html, body": {
          fontFamily: "'Amiri', serif !important",
          direction: "rtl", // Force RTL direction
        },
        "h1, h2, h3, h4, h5, h6": {
          fontFamily: "'Amiri', serif !important",
        },
      },
    },
    colors: {
      // Custom brand colors
      brand: {
        50: "#fef0ff",
        100: "#fce0ff", 
        200: "#f9c0ff",
        300: "#f6a0ff",
        400: "#f380ff",
        500: "#FA0AF2", // Main brand color
        600: "#e009d9",
        700: "#c608c0",
        800: "#ac07a7",
        900: "#92068e"
      },
      // Custom accent color
      accent: {
        50: "#e6fffd",
        100: "#ccfffb",
        200: "#99fff7",
        300: "#66fff3",
        400: "#33ffef",
        500: "#0AFAE3", // Main accent color
        600: "#09e1cc",
        700: "#08c8b5",
        800: "#07af9e",
        900: "#069687"
      },
      // Override blue-500 with your specified color
      blue: {
        50: "#eef2ff",
        100: "#e0e7ff", 
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6B95E7", // Your custom blue-500
        600: "#6366f1",
        700: "#4f46e5",
        800: "#4338ca",
        900: "#3730a3"
      }
    }
  },
  globalStyles,
  buttonStyles, // Button styles
  badgeStyles, // Badge styles
  linkStyles, // Link styles
  inputStyles, // Input styles
  CardComponent, // Card component
  MainPanelComponent, // Main Panel component
  PanelContentComponent, // Panel Content component
  PanelContainerComponent // Panel Container component
);
